import { useParams } from "react-router-dom";
import ChemicalSpecs from "./components/ChemicalSpecs";
import CommoditySpecs from "./components/CommoditySpecs";
import HeaderItemBox from "./components/common/HeaderCard";
import { useReadSpecType } from "@/libs/react-query/hooks/useSpecsQuery";
import { useEffect, useMemo, useState } from "react";
import BidDetailHeader from "@/components/BidDetailHeader";
import { BidDetailType } from "@/types/bid";
import { isNotEmpty } from "@/libs/utils";
import { GetBidDetail } from "@/services/Bid";
import { parsePrice, parseProjectType } from "./utils";
import { useSpecAnalysisStore } from "./stores/useSpecAnalysisStore";
import { SpecType } from "@/types/specs";
import Card from "./components/common/Card";
import BidAnalyticsIcon from "@/assets/images/bid-analytics-icon-dark-red.png";

export default function BidAnalytics() {
  const { projectId, projectType } = useParams();
  const [bidDetail, setBidDetail] = useState<BidDetailType>(
    {} as BidDetailType
  );

  const { sumPrice, matchRate } = useSpecAnalysisStore();

  const { data, isLoading, isError } = useReadSpecType({
    project_id: projectId ?? "",
    project_type: parseProjectType(projectType),
  });
  const { spec_type = SpecType.NONE } = data || {};

  const getBidDetail = async () => {
    if (isNotEmpty(projectId)) {
      try {
        const result = await GetBidDetail(projectId);
        setBidDetail(result.data.pods[0].content.items[0]);
      } catch (e) {
      } finally {
      }
    }
  };

  const onLoad = () => {
    getBidDetail();
  };

  useEffect(() => {
    onLoad();
  }, []);

  if (isLoading || isError) {
    return null;
  }

  return (
    <BidDetailHeader
      projectType={projectType ?? ""}
      projectId={bidDetail?.project_id}
      projectTitle={bidDetail?.title}
      isStarred={bidDetail?.is_starred}
      bidLink={bidDetail?.original_url}
      onRefresh={getBidDetail}
    >
      {spec_type !== SpecType.NONE ? (
        <div className="mt-5">
          <div className="grid grid-cols-3 gap-x-5">
            <HeaderItemBox
              title={bidDetail?.basis_amount ? "기초 금액" : "배정 예산"}
              value={`${parsePrice(bidDetail?.basis_amount || bidDetail?.budget_amount || 0)?.toLocaleString()}원`}
              isLoading={isLoading}
            />
            <HeaderItemBox
              title={headerMapBySpecType[spec_type].summary}
              value={`${parsePrice(sumPrice)?.toLocaleString()}원`}
              isLoading={isLoading}
            />
            <HeaderItemBox
              title={headerMapBySpecType[spec_type].rate}
              value={matchRate}
              className="text-dark-red"
              isLoading={isLoading}
            />
          </div>

          {spec_type === SpecType.COMMODITY ? (
            <CommoditySpecs />
          ) : spec_type === SpecType.REAGENT ? (
            <ChemicalSpecs />
          ) : null}
        </div>
      ) : (
        <div className="mt-5">
          <Card title="규격서 분석" icon={BidAnalyticsIcon}>
            <div className="flex flex-col items-center justify-center w-full h-[636px] text-gray-B">
              <p className="text-2xl font-bold">규격서 분석 정보가 없습니다</p>
              <p className="mt-2 text-sm font-normal">공고를 확인해주세요</p>
            </div>
          </Card>
        </div>
      )}
    </BidDetailHeader>
  );
}

const headerMapBySpecType = {
  [SpecType.REAGENT]: {
    summary: "자사제품 합계 (부가세 포함)",
    rate: "자사제품 비중",
  },
  [SpecType.COMMODITY]: { summary: "소비자가 합계", rate: "요구사항 일치율" },
};
